import { replace } from "react-router-redux";
// API
import { get, post } from "../../../services/api";
// Ducks
import { hideSpinner, showSpinner } from "../../../services/spinner.ducks";
import { BASE_URL } from "../../../config/constants";
import {
  setErrorNotification,
  setNotification
} from "../../../components/SmartNotification/SmartNotification.ducks";

const CLEAR_DATES = `CLEAR_DATES`;
const CLEAR_LOADING = `CLEAR_LOADING`;
const CLEAR_MISSING_EXAMS_PARTS = `CLEAR_MISSING_EXAMS_PARTS`;
const GET_NEXT_DATES_SUCCESS = `GET_NEXT_DATES_SUCCESS`;
const RESET_EXAMINATION_DATA = `RESET_EXAMINATION_DATA`;
const SET_DATES = `SET_DATES`;
const SET_LICENCES = `SET_LICENCES`;
const SET_LOADING = `SET_LOADING`;
const SET_MISSING_EXAMS_PARTS = `SET_MISSING_EXAMS_PARTS`;
const SET_NO_DATES_FLAG = `SET_NO_DATES_FLAG`;
const SET_PARTS = `SET_PARTS`;
const SET_SELECTED_DATE = `SET_SELECTED_DATE`;
const SET_LOCATIONS = `SET_LOCATIONS`;
const SET_LOCATION_DETAILS = `SET_LOCATION_DETAILS`;
const RESET_LOCATION_DETAILS = `RESET_LOCATION_DETAILS`;
const SET_OCCUPIED_SLOTS = `SET_OCCUPIED_SLOTS`;
const SET_SELECTED_SLOTS = `SET_SELECTED_SLOTS`;
const CLEAR_PARTS = `CLEAR_PARTS`;
const SET_ADMIN_QUALIFICATION_CONFIRMATION_FLAG = `SET_ADMIN_CONFIRMATION_FLAG`;

const defaultState = {
  areThereNoDates: false,
  count: 0,
  dates: [],
  filtered: `none`,
  isLoading: false,
  licences: [],
  missingExamParts: null,
  parts: [],
  selectedDateObject: {},
  locations: [],
  locationDetails: undefined,
  occupiedSlots: undefined,
  selectedSlots: undefined,
  requiresQualificationConfirmation: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case CLEAR_PARTS:
      return { ...state, parts: defaultState.parts };
    case CLEAR_DATES:
      return { ...state, dates: [], count: 0, areThereNoDates: false, filtered: `none` };
    case CLEAR_LOADING:
      return { ...state, isLoading: false };
    case CLEAR_MISSING_EXAMS_PARTS:
      return { ...state, missingExamParts: null };
    case GET_NEXT_DATES_SUCCESS:
      return {
        ...state,
        dates: [...state.dates, ...action.payload.results],
        count: action.payload.count
      };
    case RESET_EXAMINATION_DATA:
      return { ...defaultState, missingExamParts: state.missingExamParts };
    case SET_DATES:
      return {
        ...state,
        dates: action.payload.results,
        count: action.payload.count,
        filtered: action.payload.filtered
      };
    case SET_LICENCES:
      return { ...state, licences: action.payload };
    case SET_LOADING:
      return { ...state, isLoading: true };
    case SET_MISSING_EXAMS_PARTS:
      return { ...state, missingExamParts: { ...action.payload } };
    case SET_NO_DATES_FLAG:
      return { ...state, areThereNoDates: action.payload };
    case SET_PARTS:
      return { ...state, parts: action.payload };
    case SET_SELECTED_DATE:
      return { ...state, selectedDateObject: action.payload };
    case SET_LOCATIONS:
      return { ...state, locations: action.payload };
    case SET_LOCATION_DETAILS:
      return { ...state, locationDetails: action.payload };
    case RESET_LOCATION_DETAILS:
      return {
        ...state,
        locationDetails: defaultState.locationDetails,
        occupiedSlots: defaultState.occupiedSlots,
        selectedSlots: defaultState.selectedSlots
      };
    case SET_OCCUPIED_SLOTS:
      return { ...state, occupiedSlots: action.payload };
    case SET_SELECTED_SLOTS:
      return { ...state, selectedSlots: action.payload };
    case SET_ADMIN_QUALIFICATION_CONFIRMATION_FLAG:
      return { ...state, requiresQualificationConfirmation: action.payload };
    default:
      return state;
  }
};

// Actions
export const setOccupiedSlots = (payload) => ({
  type: SET_OCCUPIED_SLOTS,
  payload
});

export const resetLocationDetails = () => ({
  type: RESET_LOCATION_DETAILS
});

export const clearParts = () => ({
  type: CLEAR_PARTS
});

export const clearDates = () => ({
  type: CLEAR_DATES
});

export const clearLoading = () => ({
  type: CLEAR_LOADING
});

export const clearMissingExamsParts = () => ({
  type: CLEAR_MISSING_EXAMS_PARTS
});

export const getNextDatesSuccess = (payload) => ({
  type: GET_NEXT_DATES_SUCCESS,
  payload
});

export const resetExaminationData = () => ({
  type: RESET_EXAMINATION_DATA
});

export const setDates = (dates) => ({
  type: SET_DATES,
  payload: dates
});

export const setLicences = (licences) => ({
  type: SET_LICENCES,
  payload: licences
});

export const setAdminQualificationConfirmationFlag = (requiresQualificationConfirmation) => ({
  type: SET_ADMIN_QUALIFICATION_CONFIRMATION_FLAG,
  payload: requiresQualificationConfirmation
});

export const setLocations = (locations) => ({
  type: SET_LOCATIONS,
  payload: locations
});

export const setLoading = () => ({
  type: SET_LOADING
});

export const setMissingExamsParts = (payload) => ({
  type: SET_MISSING_EXAMS_PARTS,
  payload
});

export const setNoDatesFlag = (flag) => ({
  type: SET_NO_DATES_FLAG,
  payload: flag
});

export const setParts = (parts) => ({
  type: SET_PARTS,
  payload: parts
});

export const setSelectedDate = (dateObject) => ({
  type: SET_SELECTED_DATE,
  payload: dateObject
});

export const setLocationDetails = (locationDetails) => ({
  type: SET_LOCATION_DETAILS,
  payload: locationDetails
});

export const setSelectedSlots = (selectedSlots) => ({
  type: SET_SELECTED_SLOTS,
  payload: selectedSlots
});

// Thunks
export const fetchLocationBookings = ({ locationId, date, offset }) => async (
  dispatch,
  getState
) => {
  const {
    users: { selectedCandidate }
  } = getState();

  try {
    dispatch(showSpinner());
    const response = await dispatch(
      get(
        `/admin/locations/${locationId}/bookings?userId=${
          selectedCandidate.id
        }&date=${date}&offset=${offset}`
      )
    );
    dispatch(setOccupiedSlots(response.data.results));
    dispatch(hideSpinner());
  } catch (error) {
    dispatch(hideSpinner());
  }
};

export const fetchLocationDetails = ({ locationId }) => async (dispatch, getState) => {
  const {
    users: { selectedCandidate }
  } = getState();

  try {
    dispatch(showSpinner());
    const response = await dispatch(
      get(`/admin/locations/${locationId}?userId=${selectedCandidate.id}`)
    );
    dispatch(setLocationDetails(response.data));
    dispatch(hideSpinner());
  } catch (error) {
    dispatch(hideSpinner());
  }
};

export const fetchLocations = () => async (dispatch, getState) => {
  const {
    users: { selectedCandidate }
  } = getState();

  try {
    dispatch(showSpinner());
    const response = await dispatch(get(`/admin/locations?userId=${selectedCandidate.id}`));
    dispatch(setLocations(response.data));
    dispatch(hideSpinner());
  } catch (error) {
    dispatch(hideSpinner());
  }
};

export const fetchLicences = () => async (dispatch, getState) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  const url = isAdmin ? `/admin/licences?userId=${selectedCandidate.id}` : `/licences`;

  try {
    dispatch(showSpinner());
    const response = await dispatch(get(url));
    const licences = response.data.map((licence) => ({
      key: licence.id,
      value: licence.name
    }));
    dispatch(setLicences(licences));

    if (isAdmin) {
      const response = await dispatch(get(`/admin/requiresQualificationConfirmationByAdmin`));
      dispatch(setAdminQualificationConfirmationFlag(response.data));
    } else {
      dispatch(setAdminQualificationConfirmationFlag(false));
    }

    dispatch(hideSpinner());
  } catch (error) {
    dispatch(hideSpinner());
  }
};

export const fetchLicencesManualBooking = () => async (dispatch, getState) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  const url = isAdmin
    ? `/admin/licencesForManualBooking?userId=${selectedCandidate.id}`
    : `/licences`;

  try {
    dispatch(showSpinner());
    const response = await dispatch(get(url));
    const licences = response.data.map((licence) => ({
      key: licence.id,
      value: licence.name
    }));
    dispatch(setLicences(licences));
    dispatch(hideSpinner());
  } catch (error) {
    dispatch(hideSpinner());
  }
};

export const fetchPartsManualBooking = (licenceId) => async (dispatch, getState) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  const url = isAdmin
    ? `/admin/licencesForManualBooking/${licenceId}/parts?userId=${selectedCandidate.id}`
    : `/licences/${licenceId}/parts`;

  if (licenceId) {
    try {
      dispatch(showSpinner());
      const response = await dispatch(get(url));
      const newParts = response.data.map((part) => ({
        ...part,
        key: part.id,
        value: part.name
      }));
      dispatch(setParts(newParts));
      dispatch(hideSpinner());
    } catch (error) {
      dispatch(hideSpinner());
    }
  }
};

export const fetchParts = (licenceId) => async (dispatch, getState) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  const url = isAdmin
    ? `/admin/licences/${licenceId}/parts?userId=${selectedCandidate.id}`
    : `/licences/${licenceId}/parts`;

  if (licenceId) {
    try {
      dispatch(showSpinner());
      const response = await dispatch(get(url));
      const newParts = response.data.map((part) => ({
        ...part,
        key: part.id,
        value: part.name
      }));
      dispatch(setParts(newParts));
      dispatch(hideSpinner());
    } catch (error) {
      dispatch(hideSpinner());
    }
  }
};

export const fetchDates = ({ licenceId, offset = 0, pageSize = 15, partsId, startDate }) => async (
  dispatch,
  getState
) => {
  if (!licenceId) return;

  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  let url = isAdmin
    ? `/admin/dates?userId=${selectedCandidate.id}&startDate=${startDate}`
    : `dates?startDate=${startDate}`;

  partsId.forEach((partId) => {
    url += `&partsId=${partId}`;
  });

  url = `${url}&offset=${offset}&pageSize=${pageSize}`;

  try {
    dispatch(setLoading());

    if (!offset) {
      dispatch(showSpinner());
      dispatch(clearDates());
    }

    const { data } = await dispatch(get(url));

    if (data.results.length > 0) {
      if (!offset) {
        dispatch(setDates(data));
      } else {
        dispatch(getNextDatesSuccess(data));
      }
    } else {
      dispatch(setNoDatesFlag(true));
    }

    dispatch(clearLoading());
    dispatch(hideSpinner());
  } catch (error) {
    dispatch(hideSpinner());
    dispatch(clearLoading());
  }
};

export const manualBooking = (bookingData) => async (dispatch, getState) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  if (isAdmin) {
    const url = `/admin/manualBooking`;
    const redirectUrl = `${BASE_URL}/dashboard/bookings`;

    try {
      dispatch(showSpinner());
      await dispatch(
        post(url, {
          ...bookingData,
          candidateId: selectedCandidate.id
        })
      );
      dispatch(replace(redirectUrl));
      dispatch(hideSpinner());
      dispatch(
        setNotification({
          messageTranslationKey: `modules.localization.register.authenticated.smartNotifications.successfulBookingText`,
          titleTranslationKey: `modules.localization.register.authenticated.smartNotifications.successfulBookingTitle`,
          type: `success`
        })
      );
    } catch (error) {
      dispatch(hideSpinner());
      if (error.response && error.response.data && error.response.data.message) {
        dispatch(
          setErrorNotification({
            messageTranslationKey:
              error.response.data.message ||
              `modules.localization.register.anonymous.smartNotifications.error.generic`,
            titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
          })
        );
      }
    }
  }
};
